import React, { useState, useEffect, useContext } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Input from "./../management/input";
import { useForm, Controller } from "react-hook-form";
import Select from "./../management/select";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { getCustomerTypehub, savedatacustomer } from "../../services/wms";
import { toast } from "react-toastify";
import BranchContext from "./../context/branch";

const schema = yup.object({});

const Modaleditcustomer = ({ isOpen, onCancel, list }) => {
  const [dataproduct, setdataproduct] = useState([]);
  const [askConfirm, setaskConfirm] = useState(false);
  const [onsave, setonsave] = useState(false);
  const { currentBranch } = useContext(BranchContext);
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
    control,
  } = useForm({ resolver: yupResolver(schema) });

  useEffect(() => {
    if (list && list.length > 0) {
      reset({
        fname: list[0].name,
        identityid: list[0].identityid,
        customertypeid: list[0].customertypeid,
        id: list[0].code,
        amphur: list[0].amphur,
        moo: list[0].moo,
        tumbon: list[0].tumbon,
        provincename: list[0].provincename,
        address: list[0].address,
      });
    }
  }, [list]);

  useEffect(() => {
    const loadData = async () => {
      const { data: result } = await getCustomerTypehub();

      if (result) {
        setdataproduct(result);
      }
    };
    loadData();
  }, []);

  const handleConfirmSubmit = () => {
    // doSubmit();
    setaskConfirm(false);
  };
  const onSubmit = async (data) => {
    //    console.log("data",data)
    // console.log("list",list[0].identityid)
    try {
      const doc = {
        customer_code: list[0].code,
        branchid: currentBranch._id,
        masterid: "1",
        GUserName: 0,
        statusid: "2",
        comment: "",
        identityid_old: list[0].identityid,
        dentityid_new: data.identityid,
        cusname_old: list[0].name,
        cusname_new: data.fname,
        custype_old: list[0].customertypeid,
        custype_new: data.customertypeid,
      };
      setonsave(true);
      const { data: result } = await savedatacustomer(doc);

      if (result.status === "success") {
        setonsave(false);
        toast.success("บันทึกเสร็จเรียบร้อย");
        onCancel(false);
      } else {
        setonsave(false);
      }
    } catch (err) {
      setonsave(false);
      // toast.error("Error Try Catch");
    }
  };
  const handleaskConfirm = () => {
    setaskConfirm(true);
  };
  const handleCancleSubmit = () => {
    setaskConfirm(false);
  };
  const handleCancle = (e) => {
    onCancel(false);
  };
  const [message, setmessage] = useState("");
  return (
    <>
      <form onSubmit={(e) => e.preventDefault()}>
        <Modal
          className="modal-dialog modal-xl"
          isOpen={isOpen}
          toggle={onCancel}
        >
          <ModalHeader className="p-1 ms-2">
            <p className="text-primary me-2  fs-2 fw-bold ">
              <i className="bi bi-person-lines-fill me-2" />
              แก้ไขโปรไฟล์ลูกค้า
            </p>
          </ModalHeader>
          <ModalBody>
            <div className="card  ">
              <div className="card-mb  d-flex align-items-center justify-content-center  bg-primary text-light">
                <span aria-hidden="true" className="fa fa-user me-2"></span>
                ข้อมูลลูกค้า
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-6    ">
                    <Input
                      icon="bi bi-bag-plus-fill text-info me-2"
                      label="รหัสลูกค้า"
                      name="id"
                      register={register}
                      required
                      errors={errors.code}
                      disabled
                    />
                  </div>
                  <div className="col-lg-6 ">
                    <Select
                      icon="bi bi-book-half  text-info me-2"
                      label="ประเภทลูกค้า"
                      name="customertypeid"
                      list={dataproduct}
                      {...register("customertypeid")}
                      required
                      errors={errors.customertypeid}
                    />
                  </div>

                  <div className="col-lg-6 col-xs-12">
                    <div className="row">
                      <div className="col-lg-12 col-xs-12">
                        <Input
                          icon="bi bi-person-check-fill  text-info me-2"
                          label="ชื่อ-นามสกุล"
                          name="fname"
                          register={register}
                          required
                          errors={errors.fname}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-xs-12">
                    <Input
                      icon="bi bi-bag-plus-fill text-info me-2"
                      label="รหัสบัตรประชาชน"
                      name="identityid"
                      register={register}
                      required
                      errors={errors.codeid}
                      // maxlength={13}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12 ">
                <div className="card  ">
                  <div className="d-flex align-items-center justify-content-center  bg-success text-light">
                    <span
                      aria-hidden="true"
                      className="fa fa-address-card me-2"
                    ></span>
                    ข้อมูลที่อยู่
                  </div>

                  <div className="row m-1">
                    <div className="col-lg-6 col-xs-12">
                      <Input
                        icon="bi bi-house-door-fill text-info me-2"
                        label="เลขที่"
                        name="address"
                        register={register}
                        required
                        errors={errors.address}
                        disabled
                      />
                    </div>
                    <div className="col-lg-6 col-xs-12">
                      <Input
                        icon="bi bi-bank2 text-info me-2"
                        label="หมู่ "
                        name="moo"
                        register={register}
                        required
                        errors={errors.moo}
                        disabled
                      />
                    </div>
                    <div className="col-lg-6 col-xs-12">
                      <Input
                        icon="bi bi-map-fill text-info me-2"
                        label="ตำบล "
                        name="tumbon"
                        register={register}
                        required
                        errors={errors.tumbol}
                        disabled
                      />
                    </div>
                    <div className="col-lg-6 col-xs-12">
                      <Input
                        icon="bi bi-shop-window text-info me-2"
                        label="อำเภอ "
                        name="amphur"
                        register={register}
                        required
                        errors={errors.aumper}
                        disabled
                      />
                    </div>
                    <div className="col-lg-6 col-xs-12">
                      <Input
                        icon="bi bi-server text-info me-2"
                        label="จังหวัด "
                        name="provincename"
                        register={register}
                        required
                        errors={errors.provincename}
                        disabled
                      />
                    </div>
                    <div className="col-lg-6 col-xs-12">
                      <Input
                        icon="bi bi-mailbox2 text-info me-2"
                        label="รหัสไปรษณีย์ "
                        name="zipcode"
                        register={register}
                        required
                        errors={errors.zipcode}
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-xs-12 mt-2">
                <Input
                  icon="bi bi-mailbox2 text-info me-2"
                  label="เหตุผล"
                  name="comment"
                  register={register}
                  required
                  errors={errors.comment}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="col-auto me-3">
              <div className="row">
                <div className=" col-auto ">
                  {/* <Button color="primary" onClick={handleSubmit(handleaskConfirm)}>
                    Confirm
                  </Button> */}
                  <Button color="primary" disabled ={onsave} onClick={handleSubmit(onSubmit)}>
                    Confirm
                  </Button>
                </div>
                <div className=" col-auto ">
                  <Button color="secondary" onClick={handleCancle}>
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </ModalFooter>
        </Modal>
      </form>
    </>
  );
};

export default Modaleditcustomer;
